
import axiosInstance, { getAPIURL } from "../axiosInstance";
import { useQuery } from "@tanstack/react-query";
import { Event, PaginatedResponse, Params } from "../../types/Types";

type UpcomingParams = Pick<Params, "enabled" | "pageSize" | "page" | "searchTerm"> & {
  /** Passed to API as `location` (exact match, case-insensitive). */
  location?: string;
};

export function useFindUpcomingEvents({
  enabled = true,
  pageSize = 10,
  page = 1,
  location,
  searchTerm,
}: UpcomingParams = {}) {
  return useQuery({
    enabled,
    queryKey: ["events", "upcoming", { pageSize, page, location, searchTerm }],
    queryFn: async () => {
      let url = getAPIURL(
        `/Event/Upcoming?pageNumber=${page}&pageSize=${pageSize}`,
      );
      if (location?.trim()) {
        url += `&location=${encodeURIComponent(location.trim())}`;
      }
      if (searchTerm?.trim()) {
        url += `&searchTerm=${encodeURIComponent(searchTerm.trim())}`;
      }
      return axiosInstance<PaginatedResponse<Event>>(url).then(
        (res) => res.data,
      );
    },
  });
}
